<div id="health" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Health & Medical Facilities</h2>
    <p class="inner-lead mt-3">
      The well-being of our students is a top priority. Shah Satnam Ji Girls' College provides a supportive environment with immediate medical assistance available on campus.
    </p>

    <hr class="divider">

    <div class="row g-4 mt-2">
      <div class="col-md-6">
        <h4 class="section-subtitle">On-Campus Care</h4>
        <ul class="inner-lead">
          <li><strong>First Aid Room:</strong> A dedicated medical room stocked with essential supplies and emergency first-aid kits.</li>
          <li><strong>Trained Staff:</strong> Supervised by personnel trained in basic emergency medical response and first aid.</li>
          <li><strong>Regular Check-ups:</strong> Periodical health awareness camps and medical screenings for students.</li>
        </ul>
      </div>
      <div class="col-md-6">
        <h4 class="section-subtitle">Emergency Support</h4>
        <ul class="inner-lead">
          <li><strong>Hospital Tie-up:</strong> The college has a primary support tie-up with <strong>Shah Satnam Ji Speciality Hospital, Sirsa</strong>.</li>
          <li><strong>Proximity:</strong> The hospital is located in the immediate vicinity for rapid response in case of advanced medical needs.</li>
          <li><strong>Emergency Transport:</strong> On-call vehicle support for transporting students to the hospital when necessary.</li>
        </ul>
      </div>
    </div>

    <div class="mt-section text-center">
       <p class="text-muted small"><em>Providing a safe and healthy foundation for academic success.</em></p>
    </div>

  </div>
</div>
